
// Load on view
jQuery(window).on('scroll', function() {
  jQuery('.stats-wrapper:not(.in-view)').each(function() {
      if (isInView(jQuery(this))) {
          console.log('Element is in view!');
          jQuery(this).addClass('in-view'); // Ensure it only triggers once

          // This is the number counter
          jQuery('.stats-wrapper .count').each(function () {
            jQuery(this).prop('Counter',0).animate({
              Counter: jQuery(this).text()
            }, {
              duration: 4000,
              easing: 'swing',
              step: function (now) {
                jQuery(this).text(Math.ceil(now));
              }
            });
          });
      }
  });
});


function isInView(element) {
  const windowTop = jQuery(window).scrollTop();
  const windowBottom = windowTop + jQuery(window).height();
  const elementTop = element.offset().top;
  const elementBottom = elementTop + element.height();

  return elementBottom > windowTop && elementTop < windowBottom;
}